import { Injectable } from '@angular/core';
import {DraftInspection} from "../../../models/inspection.model";

@Injectable({
    providedIn: 'root',
})
export class InspectionDraftService {
    private draft: DraftInspection = {};

    getDraft(): DraftInspection {
        return this.draft;
    }

    updateDraft(data: Partial<DraftInspection>): void {
        this.draft = { ...this.draft, ...data };
    }

    resetDraft(): void {
        this.draft = {};
    }
}
